<template>
  <vs-popup class="customer-sample-order-create-popup"
            title="UPDATE CUSTOMER PRODUCT ORDER"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="popup" @submit.prevent="handleSubmit(onClickUpdateProductOrder)" autocomplete="off">

          <div class="vx-row mb-3" v-if="onClickAddressChange">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="formulation_items" name="formulation_items" rules="" v-slot="{ errors }">
                <small class="label">Select a delivery address to change</small>
                <v-select
                  v-on:input="onChangeSelectDeliveryAddress"
                  @search="onSearch"
                  name="formulation_items" placeholder=""
                  :reduce="option => option"
                  label="country"
                  :options="addresses" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      <span style="font-weight: normal">{{ option.name }}</span> <br>
                      <span style="font-weight: normal">{{ option.line1 }}</span> <br>
                      <span style="font-weight: normal">{{ option.line2 }}</span> <br>
                      <span style="font-weight: normal">{{ option.line3 }}</span> <br>
                      <span style="font-weight: normal">{{ option.town_state }}</span> <br>
                      <span style="font-weight: normal">{{ option.post_code }}</span> <br>
                      <span style="font-weight: normal">{{ option.country }}</span> <br>
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      <span style="font-weight: normal">{{ option.name }}</span> <br>
                      <span style="font-weight: normal">{{ option.line1 }}</span> <br>
                      <span style="font-weight: normal">{{ option.line2 }}</span> <br>
                      <span style="font-weight: normal">{{ option.line3 }}</span> <br>
                      <span style="font-weight: normal">{{ option.town_state }}</span> <br>
                      <span style="font-weight: normal">{{ option.post_code }}</span> <br>
                      <span style="font-weight: normal">{{ option.country }}</span> <br>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </div>
          </div>

         <span v-if="!onClickAddressChange">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Address Name</small>
                <vs-input v-model="createForm.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
           <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                <small class="label">Address Line 1</small>
                <vs-input v-model="createForm.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                <small class="label">Address Line 2</small>
                <vs-input v-model="createForm.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
           <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                <small class="label">Address Line 3</small>
                <vs-input v-model="createForm.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                <small class="label">Town / State</small>
                <vs-input v-model="createForm.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
           <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                <small class="label">Postal Code</small>
                <vs-input v-model="createForm.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                          label="name" v-model="createForm.country" :reduce="option => option.name"
                          :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
           <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <span style="cursor: pointer" class="float-right text-primary" @click="onClickAddressChange = true">change delivery address</span>
            </div>
          </div>
         </span>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="delivery_instruction" name="delivery_instruction" rules="" v-slot="{ errors }">
                <small class="label">Delivery Instructions</small>
                <vs-textarea class="mb-0" v-model="createForm.delivery_instruction" height="150px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const FormulationsRepository = RepositoryFactory.get('formulations');

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      customerId: '',
      createForm: {
        name: '',
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: '',
        delivery_instruction:''
      },
      countryCodes: [],
      addresses: [],
      onClickAddressChange: false
    }
  }

  export default {
    name: 'TrackingImagePopUp',
    data () {
      return initialState()
    },
    methods:{
      async openPopup (id, customerId) {
        try {
          await Object.assign(this.$data, initialState())
          this.id = id
          this.customerId = customerId
          await this.getCountryCodes()
          await this.getAddresses()
          await this.getProductOrdersOrder()
          this.open = true;
        } catch (error) {

        }
      },
      async onClickUpdateProductOrder () {
        const vue = this;
        await this.$vs.loading({
          container: '#popup',
          scale: 0.45
        })
        try {
          await CustomerRepository.updateCustomerProductOrder(this.id, this.createForm)
          this.showSuccessMessage('Product order update successfully')
          await vue.$parent.refreshData()
          this.open = false;
        }catch (e) {
          this.$vs.loading.close('#popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#popup > .con-vs-loading')
      },
      async getProductOrdersOrder() {
        this.$vs.loading()
        const {data} = await CustomerRepository.getCustomerProductOrder(this.id)
        this.createForm.name =  data.data.name
        this.createForm.line1 =  data.data.line1
        this.createForm.line2 =  data.data.line2
        this.createForm.line3 =  data.data.line3
        this.createForm.town_state =  data.data.town_state
        this.createForm.post_code =  data.data.post_code
        this.createForm.country =  data.data.country
        this.createForm.delivery_instruction =  data.data.delivery_instruction
        this.$vs.loading.close()
      },
      async getCountryCodes() {
        this.$vs.loading()
        this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
        this.$vs.loading.close()
      },
      async getAddresses() {
        this.$vs.loading()
        this.addresses = (await CustomerRepository.getCustomerProductDeliveryAddresses(this.customerId)).data.data;
        this.$vs.loading.close()
      },
      onChangeSelectDeliveryAddress(selected) {
        this.createForm.name = selected.name
        this.createForm.line1 = selected.line1
        this.createForm.line2 = selected.line2
        this.createForm.line3 = selected.line3
        this.createForm.town_state = selected.town_state
        this.createForm.post_code = selected.post_code
        this.createForm.country = selected.country
        this.onClickAddressChange = false
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
    },
    async mounted () {

    },
    computed: {

    },
    components: {
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .customer-sample-order-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }
  .loader {
    text-align: center;
    color: #bbbbbb;
  }

</style>
